"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks to see if a given value is `null` or `undefined`
 *
 * @example
 * import isNil from '@carvana/futilities/isNil';
 * isNil(null)
 * // () => true
 * isNil()
 * // () => true
 * isNil('undefined')
 * // () => false
 * isNil(999)
 * // () => false
 */
function isNil(val) {
    return val == null;
}
exports.default = isNil;
//# sourceMappingURL=isNil.js.map